var map = {
	"./cloudInforImages/img_0.png": "17ff",
	"./cloudInforImages/img_1.png": "706e",
	"./cloudInforImages/img_2.png": "6cac",
	"./cloudInforImages/img_3.png": "bbd3",
	"./cloudInforImages/img_4.png": "9f02",
	"./cloudInforImagesZh/img_0.png": "0920",
	"./cloudInforImagesZh/img_1.png": "ced7",
	"./cloudInforImagesZh/img_2.png": "8e9d",
	"./cloudInforImagesZh/img_3.png": "1b59",
	"./cloudInforImagesZh/img_4.png": "c88c",
	"./cloudInforImagesZh/img_5.png": "9f38",
	"./cloudInforImagesZh/img_6.png": "2a0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1e21";